<div class="flex flex-col gap-2">
  <p class="text-xl">Http Error Message:</p>
  <p>{{ error.error.message }}</p>
  <ng-container *ngIf="!isProduction">
    <hr>
    <button (click)="showMore.set(true)"
            *ngIf="!showMore()"
            class="px-4 py-2 rounded bg-accent-500">
      <ng-container i18n>Show more details</ng-container>
    </button>
    <eurogard-any-http-error *ngIf="showMore()"></eurogard-any-http-error>
  </ng-container>
</div>
